/*
 * Piper: saves the "Is this a gift?" checkbox (snippets/pep-cart-gift.liquid) to the cart as soon as it changes,
 * so it survives cart drawer re-renders and express checkout buttons. Delegated, so re-rendered markup needs no setup.
 */
(function () {
  document.addEventListener('change', function (event) {
    const box = event.target;
    if (!box.matches || !box.matches('[data-pep-gift]')) return;

    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { [box.dataset.pepGift]: box.checked ? box.value : '' } }), // '' removes it
    }).catch(function (error) {
      console.warn('[pep-gift] could not save', error);
    });
  });
})();
